import { render } from "./accordion-snippet.vue?vue&type=template&id=34d85b5b"
import script from "./accordion-snippet.vue?vue&type=script&lang=js"
export * from "./accordion-snippet.vue?vue&type=script&lang=js"

import "./accordion-snippet.vue?vue&type=style&index=0&id=34d85b5b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__